import ReportsApi from './ReportsApi';
export default ReportsApi;
